import React, { useEffect, useMemo } from "react";
import { FeatureFlags, getFeatureFlags } from "src/consts/featureFlags";
import { useCurrentUserClinic } from "src/data/queries/useCurrentUserClinic";

interface FeatureFlagsFilterContextProps {
  featureFlags: FeatureFlags;
  loading: boolean;
}

const ctx = React.createContext<FeatureFlagsFilterContextProps | null>(null);

export const FeatureFlagsFilterProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const { clinic, loading } = useCurrentUserClinic();

  const featureFlags = useMemo(() => getFeatureFlags(clinic?.featureFlags), [clinic?.featureFlags]);

  useEffect(() => {
    // Adding featureFlags to the window element for Cypress testing
    if (typeof window !== "undefined") {
      (window as any).featureFlags = featureFlags;
    }
  }, [featureFlags]);

  const value: FeatureFlagsFilterContextProps = { featureFlags, loading };
  return <ctx.Provider value={value}>{children}</ctx.Provider>;
};

export const useFeatureFlags = () => {
  const context = React.useContext(ctx);
  if (!context) {
    throw new Error("useFeatureFlags must be used within a FeatureFlagsFilterProvider");
  }
  return context;
};
